// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { QuestRoute } from './api/QuestRoutes';
import { Regex } from './api/regex';
import Form from './form/Form';
import Input from './form/Input';
import { useGlobalState } from './globalState/GlobalStateProvider';
import { getDaysInMonth } from './api/utility';
import { HamQuest } from '../../App';

const Row = styled.div`
    display: flex;
`

const AccountForm = ({ open, updateOpenState, accountdetails, ...props }) => {
    const {
        state: {
            active_user,
        },
        getUser,
        logIn
    } = useGlobalState();

    const formProps = { ...props };
    delete formProps.password;
    delete formProps.referral;

    // const newEmail = generateId(10)

    return (
        <Form
            inputs={{
                firstName: '',
                lastName: '',
                email: '',
                birthdayMonth: '',
                birthdayDay: '',
                zipPostalCode: '',
                cellPhoneNumber: '',
                password: '',
                referralCode: window.location.hash?.replace('#', '') || '',

                confirmEmail: '',
                confirmpassword: '',

                // firstName: 'Frank',
                // lastName: 'Furt',
                // email: newEmail + '@Ham.com',
                // birthdayMonth: '5',
                // birthdayDay: '10',
                // zipPostalCode: '12345',
                // cellPhoneNumber: '4195555555',
                // password: 'Password!2',
                // referralCode: '',

                // confirmEmail: newEmail + '@Ham.com',
                // confirmpassword: 'Password!2',
            }}
            onSubmit={(e) => {
                const newBody = { ...e }
                if (props.signup) {
                    delete newBody.confirmEmail;
                    delete newBody.confirmpassword;
                    return HamQuest.post(QuestRoute.user.signUp, newBody, { captcha: window.siteKey })
                        .then(async () => {
                            await logIn({
                                email: newBody.email,
                                password: newBody.password
                            })
                        })
                } else {
                    delete newBody.confirmEmail;
                    return HamQuest.postPost(QuestRoute.user.signUp, newBody)
                        .then(() => getUser())
                }
            }}
            submitButton='Create Account'
            submittingButton='Creating Account'
            noValidate
            {...formProps}
        >
            {({ values }) => (
                <>
                    <Input
                        label='First Name'
                        name='firstName'
                        sanitize={/[^A-Za-z-' ]/}
                        required
                    />
                    <Input
                        label='Last Name'
                        name='lastName'
                        sanitize={/[^A-Za-z-' ]/}
                        required
                    />
                    <Input
                        label='Email'
                        name='email'
                        type='email'
                        validate={(e, setMsg, resolve) => {
                            const inputEmail = e;
                            if (e.match(Regex.match.email)) {
                                HamQuest.post(QuestRoute.validate.email, {
                                    email: e
                                })
                                    .then(e => {
                                        if (inputEmail === active_user.account?.email) {
                                            resolve(e);
                                            return;
                                        }
                                        if (!e) setMsg('Email is already associated with an account.');
                                        resolve(!e)
                                    })
                                    .catch((ex) => {
                                        setMsg(ex.blob);
                                    })
                            } else {
                                setMsg('Please enter a valid email.');
                                resolve(true)
                            }
                        }}
                        debounce={400}
                        disabled={!props.signup}
                        required
                    />
                    {
                        props.signup &&
                        <Input
                            label='Confirm Email'
                            name='confirmEmail'
                            confirmation='email'
                            type='email'
                            required
                        />
                    }
                    <Row>
                        <Input
                            label='Birth Month'
                            name='birthdayMonth'
                            type='number'
                            sanitize={Regex.match.notNumbers}
                            disabled={!props.signup}
                            max={12}
                            min={1}
                            validate={(e, setMsg, resolve) => {
                                const val = parseInt(e)
                                if (val > 0 && val < 13) {
                                    resolve(false)
                                } else {
                                    setMsg('Please enter a valid Month.');
                                    resolve(true)
                                }
                            }}
                            numpad
                        />
                        <Input
                            label='Birth Day'
                            name='birthdayDay'
                            type='number'
                            max={getDaysInMonth(values.birthdayMonth)}
                            min={1}
                            validate={(e, setMsg, resolve) => {
                                const val = parseInt(e)
                                if (val > 0 && val < getDaysInMonth(values.birthdayMonth) + 1) {
                                    resolve(false)
                                } else {
                                    setMsg('Please enter a valid Day.');
                                    resolve(true)
                                }
                            }}
                            sanitize={Regex.match.notNumbers}
                            disabled={!props.signup}
                            numpad
                        />
                    </Row>
                    <Input
                        label='Phone Number'
                        name='cellPhoneNumber'
                        sanitize={Regex.match.notNumbers}
                        validate={Regex.test.phonenumber}
                        mask={Regex.mask.phoneNumber}
                        numpad
                    />
                    <Input
                        label='Postal Code'
                        name='zipPostalCode'
                        validate={/\w+/g}
                    />
                    {
                        props.password ?
                            <>
                                <Input
                                    label='Password'
                                    name='password'
                                    type='password'
                                    validate={Regex.test.password}
                                    required
                                />
                                <Input
                                    label='Confirm Password'
                                    name='confirmpassword'
                                    type='password'
                                    confirmation='password'
                                    required
                                />
                            </>
                            : null
                    }
                    {
                        props.referral ?
                            <Input
                                label='Referral Code'
                                name='referralCode'
                            />
                            : null
                    }
                </>
            )}

        </Form>
    );
}

export default AccountForm;
